export default {"src":"/_next/static/media/celebChoice.8083c9fa.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};